(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaSettingsWeekSchemeController', ['ItemTableService', AgendaSettingsWeekSchemeControllerFn]);

    /* controlle for main week schemes */
    function AgendaSettingsWeekSchemeControllerFn(ItemTableService) {
        var vm = this;

        // table service data
        vm.overview = null;

        activate();

        /* activation work */
        function activate() {
            vm.overview = ItemTableService; // no instance of Service -> just the service !!! no need for "new"
        } // activate
    }
})();
